"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
    d: "M12 5.292c-4.549 0-8.25 2.776-8.25 6.188 0 1.703.898 3.288 2.526 4.463.318.231.489.481.525.765.066.528-.348 1.035-.35 1.038a.515.515 0 0 0 .252.83c.042.012.482.131 1.083.131.792 0 1.862-.218 2.672-1.156.506.071 1.021.115 1.541.115 4.549 0 8.25-2.776 8.25-6.188s-3.701-6.187-8.25-6.187zm0 11.344c-.565 0-1.127-.047-1.67-.139l-.001.005a.51.51 0 0 0-.506.204c-.607.85-1.511 1.001-2.155.97.121-.303.206-.677.158-1.086-.069-.578-.387-1.077-.944-1.481l-.002-.001c-1.354-.976-2.1-2.264-2.1-3.628 0-2.843 3.239-5.156 7.219-5.156s7.219 2.313 7.219 5.156-3.239 5.156-7.219 5.156z"
}), 'Message'); //# sourceMappingURL=index.js.map
